import React from 'react';
import styled from 'styled-components';
import { Icon } from 'ensightful-koala-ui';

const ButtonContainer = styled.div`
    background: ${(props) => (props.active ? props.activeColor : props.inactiveColor)};
    border-radius: 10px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: ${(props) => `${props.size}px`};
    height: ${(props) => `${props.size}px`};
    padding: 5px;

    &:hover {
        cursor: pointer;
        ${(props) => (props.active ? 'background-color: #4136c0' : '')};
    }

    & svg {
        width: ${(props) => (props.iconSize ? props.iconSize : '20px')};
        height: ${(props) => (props.iconSize ? props.iconSize : '20px')};
    }

    & svg path {
        fill: ${(props) => props.iconColor};
    }
`;

const IconButton = ({
    active = false,
    kind = 'plus',
    activeColor = '#6347ff',
    inactiveColor = 'transparent',
    iconColor = 'white',
    iconSize = null,
    size = 20,
    ...props
}) => {
    return (
        <ButtonContainer
            active={active}
            activeColor={activeColor}
            inactiveColor={inactiveColor}
            size={size}
            iconColor={iconColor}
            iconSize={iconSize}
            {...props}
        >
            <Icon kind={kind} size={size} fill={iconColor} />
        </ButtonContainer>
    );
};

export default IconButton;
